<div class="content">
    <span class="mat-title">
        Usuários da conta
    </span>

    <div class="controls" *ngIf="currentUser.is_admin == 'true'">
        <button mat-raised-button color="primary" (click)="openUserDialog()">Novo usuário</button>
    </div>

    <mat-action-list>

        <ng-container *ngFor="let user of users">

            <button mat-list-item (click)="openUserDialog(user)">
                <img [src]="midiaEndpoint + '' + user.avatar_profile" matListAvatar *ngIf="user.avatar_profile" />
                <img src="assets/images/avatar-male.png" matListAvatar *ngIf="user.avatar_profile === null" />
                <h3 matLine>{{ user.firstname }} {{ user.lastname }}</h3>
                <p matLine>{{ user.email }}</p>
                <ng-container *ngIf="user.email != adminUser">            
                    <ng-container *ngIf="currentUser.id != user.id && currentUser.is_admin == 'true'">
                        <button mat-icon-button color="accent" (click)="deleteUser($event, user)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </ng-container>
                </ng-container>
            </button>

        </ng-container>
        
    </mat-action-list>

</div>